import * as jsxRuntime from "/Users/m.aliwi/Desktop/Websites/react-tabs-scrollable/package/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment